import './no-result.scss';
import React from 'react';
import CustomIcon, { IconType } from '../custom-icon/custom-icon';

interface NoResultProps {
    iconType?: IconType;
    title?: string;
    subTitle?: string;
    hideSubTitle?: boolean;
}

export const NoResult: React.FC<NoResultProps> = ({ iconType, title, subTitle, hideSubTitle }) => {
    return <div className="no-result">
        <CustomIcon type={iconType ?? IconType.NoResult} size={96} />
        <div className="text">{title ?? 'No Search Result'}</div>
        {!hideSubTitle && <div className="sub-text">{subTitle || ' Change the search string and try again.'} </div>}
    </div>;
};